export enum EstimatePlatformType {
  Tablet = 'TABLET',
  Phone = 'PHONE',
}
